

// Components
import Container from '@/components/Container';
import Columns from '@/components/Columns';
import Column from '@/components/Column';

import WizardTabs from '@/components/WizardTabs';
import ProductsSidebar from '@/components/ProductsSidebar';
import TopBar from '@/components/TopBar';
import Footer from '@/components/Footer';

// Types
type LayoutProps = {
  children?: React.ReactNode;
};

// Layout
export default function Layout({ children }: LayoutProps) {
  return (
    <div className='min-h-screen bg-[#f4f6f9]'>
      <TopBar />
      <div className='mx-auto max-w-7xl px-2 py-6 lg:px-6'>
        <Columns
          className='flex flex-row-reverse justify-center print:shadow-none'
          useNegativeMargin={false}
        >
          <Column size={[12, 12, 3]}>
            <ProductsSidebar />
          </Column>
          <Column size={[12, 12, 7]} className='mt-4 lg:mt-0'>
            <div className='overflow-hidden rounded-2xl bg-white shadow-sm'>
              <WizardTabs />
              <Container as='main' className='px-4 pb-10 pt-6 md:px-12'>
                {children}
              </Container>
            </div>
          </Column>
        </Columns>
        <Column className='mb-4 mt-8'>
          <Footer showText />
        </Column>
      </div>
    </div>
  );
}
